import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { decodeToString1dbzcjd620q25 as decodeToString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import { writeFully359t6q8kam2g5 as writeFully } from '../../../../../../ktor-ktor-io/io/ktor/utils/io/core/BytePacketBuilder.mjs';
import { readText3frapgncbqrcg as readText } from '../../../../../../ktor-ktor-io/io/ktor/utils/io/Deprecation.mjs';
import {
  CloseReason10cphaqpp3ct7 as CloseReason,
  Companion_getInstance3h3c6jlu8qefd as Companion_getInstance,
  Codes_CLOSED_ABNORMALLY_getInstance18g5hbbmrws6x as Codes_CLOSED_ABNORMALLY_getInstance,
  Codes_NORMAL_getInstance21orcjign6rr6 as Codes_NORMAL_getInstance,
} from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/CloseReason.mjs';
import { cancelConsumed2i0oizqhmljf6 as cancelConsumed } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channels.common.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CompletableDeferred.mjs';
import { Factory_getInstance1n4mqriubejsu as Factory_getInstance } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channel.mjs';
import { from3gpkuvfyl3bft as from } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketChannelsConfig.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  Text3e6ukp9joohql as Text,
  Binary3tlzyfojm51s4 as Binary,
  Close3tx65evcwi73t as Close,
} from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/Frame.web.mjs';
import { WebSocketExceptionb5mwyitzck0i as WebSocketException } from './WebSockets.mjs';
import { throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/internal/ThrowHelpers.mjs';
import { Key_instance17dpgmdbeabno as Key_instance } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { send3oe3simbzresd as send } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketSession.mjs';
import { DefaultWebSocketSession3h8506yqzs5fx as DefaultWebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/DefaultWebSocketSession.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  // Inline function 'kotlinx.coroutines.channels.consumeEach' call
  var tmp0 = $this.i60_1.e60_1;
  $l$block: {
    // Inline function 'kotlinx.coroutines.channels.consume' call
    var cause = null;
    try {
      var _iterator__ex2g4s = tmp0.u1();
      $l$loop: while (true) {
        var tmp = _iterator__ex2g4s.q1a($completion);
        if (tmp === get_COROUTINE_SUSPENDED())
          tmp = yield tmp;
        if (!tmp) {
          break $l$loop;
        }
        var e = _iterator__ex2g4s.w1();
        switch (e.c5b_1.b2_1) {
          case 0:
            var text = e.d5b_1;
            $this.i60_1.b60_1.send(decodeToString(text, 0, 0 + text.length | 0));
            break;
          case 1:
            var tmp_0 = e.d5b_1;
            var source = tmp_0 instanceof Int8Array ? tmp_0 : THROW_CCE();
            var frameData = source.buffer.slice(source.byteOffset, source.byteOffset + source.byteLength | 0);
            $this.i60_1.b60_1.send(frameData);
            break;
          case 2:
            // Inline function 'io.ktor.utils.io.core.buildPacket' call

            var builder = new (Buffer())();
            writeFully(builder, e.d5b_1);
            var data = builder;
            var code = data.h4f();
            var reason = readText(data);
            $this.i60_1.c60_1.u12(CloseReason().w59(code, reason));
            if (isReservedStatusCode($this.i60_1, code)) {
              $this.i60_1.b60_1.close();
            } else {
              $this.i60_1.b60_1.close(code, reason);
            }

            break;
          case 3:
          case 4:
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
      }
      break $l$block;
    } catch ($p) {
      if ($p instanceof Error) {
        var e_0 = $p;
        cause = e_0;
        throw e_0;
      } else {
        throw $p;
      }
    }
    finally {
      cancelConsumed(tmp0, cause);
    }
  }
  return Unit_instance;
}
function isReservedStatusCode($this, _this__u8e3s4) {
  // Inline function 'kotlin.let' call
  var resolved = Companion_getInstance().t59(_this__u8e3s4);
  return resolved == null || equals(resolved, Codes_CLOSED_ABNORMALLY_getInstance());
}
var JsWebSocketSession$slambdaClass;
function JsWebSocketSession$slambda() {
  if (JsWebSocketSession$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.i60_1 = this$0;
      }
      c1g($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      ud(p1, $completion) {
        return this.c1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    JsWebSocketSession$slambdaClass = $;
  }
  return JsWebSocketSession$slambdaClass;
}
function JsWebSocketSession$slambda_0(this$0) {
  var i = new (JsWebSocketSession$slambda())(this$0);
  var l = ($this$launch, $completion) => i.c1g($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var JsWebSocketSessionClass;
function JsWebSocketSession() {
  if (JsWebSocketSessionClass === VOID) {
    class $ {
      constructor(coroutineContext, websocket, channelsConfig) {
        this.a60_1 = coroutineContext;
        this.b60_1 = websocket;
        this.c60_1 = CompletableDeferred();
        this.d60_1 = from(Factory_getInstance(), channelsConfig.h5a_1);
        this.e60_1 = from(Factory_getInstance(), channelsConfig.i5a_1);
        this.f60_1 = this.d60_1;
        this.g60_1 = this.e60_1;
        this.h60_1 = this.c60_1;
        var onMessage = (e) => {
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var event = e;
          var data = event.data;
          var tmp;
          if (data instanceof ArrayBuffer) {
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$3 = new Int8Array(data);
            tmp = Binary().m5e(true, tmp$ret$3);
          } else {
            if (!(data == null) ? typeof data === 'string' : false) {
              tmp = Text().w5e(data);
            } else {
              var error = IllegalStateException().o('Unknown frame type: ' + event.type);
              this.c60_1.v12(error);
              throw error;
            }
          }
          var frame = tmp;
          this.d60_1.f1b(frame);
          return Unit_instance;
        };
        var onError = (e) => {
          var cause = WebSocketException().c5w(toString(e));
          this.c60_1.v12(cause);
          this.d60_1.p1b(cause);
          this.e60_1.t1b();
          return Unit_instance;
        };
        var onClose = {_v: null};
        onClose._v = (e) => {
          var tmp = e.code;
          var tmp_0 = (!(tmp == null) ? typeof tmp === 'number' : false) ? tmp : THROW_CCE();
          var tmp_1 = e.reason;
          var reason = CloseReason().w59(tmp_0, (!(tmp_1 == null) ? typeof tmp_1 === 'string' : false) ? tmp_1 : THROW_CCE());
          this.c60_1.u12(reason);
          this.d60_1.f1b(Close().r5b(reason));
          this.d60_1.r1b();
          this.e60_1.t1b();
          var tmp_2;
          if (onClose._v == null) {
            throwUninitializedPropertyAccessException('onClose');
          } else {
            tmp_2 = onClose._v;
          }
          this.b60_1.removeEventListener('close', tmp_2);
          return Unit_instance;
        };
        var tmp0_safe_receiver = this.a60_1.hd(Key_instance);
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.hx((cause) => {
            $l$block: {
              // Inline function 'io.ktor.client.plugins.websocket.JsWebSocketSession.runWhenOpen' call
              if (this.b60_1.readyState === WebSocket.OPEN) {
                if (cause == null) {
                  this.b60_1.close();
                } else {
                  this.b60_1.close(Codes_NORMAL_getInstance().q59_1, 'Client failed');
                }
                break $l$block;
              }
              this.b60_1.addEventListener('open', (it) => {
                if (cause == null) {
                  this.b60_1.close();
                } else {
                  this.b60_1.close(Codes_NORMAL_getInstance().q59_1, 'Client failed');
                }
                return Unit_instance;
              });
            }
            this.b60_1.removeEventListener('message', onMessage);
            this.b60_1.removeEventListener('error', onError);
            return Unit_instance;
          });
        }
        // Inline function 'org.w3c.dom.ARRAYBUFFER' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp$ret$9 = 'arraybuffer';
        this.b60_1.binaryType = tmp$ret$9;
        this.b60_1.addEventListener('message', onMessage);
        this.b60_1.addEventListener('error', onError);
        var tmp;
        if (onClose._v == null) {
          throwUninitializedPropertyAccessException('onClose');
        } else {
          tmp = onClose._v;
        }
        this.b60_1.addEventListener('close', tmp);
        launch(this, VOID, VOID, JsWebSocketSession$slambda_0(this));
        // Inline function 'kotlin.require' call
        if (!!channelsConfig.h5a_1.o5d()) {
          var message = 'Suspendable channels are not supported in JS.';
          throw IllegalArgumentException().s2(toString(message));
        }
      }
      ew() {
        return this.a60_1;
      }
      d5a() {
        return this.f60_1;
      }
      e5a() {
        return this.g60_1;
      }
      z59() {
        return this.h60_1;
      }
      b5a(_) {
        throw WebSocketException().c5w('Max frame size switch is not supported in Js engine.');
      }
      c5a() {
        return 9223372036854775807n;
      }
      a5a(negotiatedExtensions) {
        // Inline function 'kotlin.require' call
        if (!negotiatedExtensions.s1()) {
          var message = 'Extensions are not supported.';
          throw IllegalArgumentException().s2(toString(message));
        }
      }
      v4i($completion) {
        return Unit_instance;
      }
    }
    protoOf($).f5a = send;
    initMetadataForClass($, 'JsWebSocketSession', VOID, VOID, [DefaultWebSocketSession()], [0, 1]);
    JsWebSocketSessionClass = $;
  }
  return JsWebSocketSessionClass;
}
//region block: exports
export {
  JsWebSocketSession as JsWebSocketSession2h93x4rgbt7zw,
};
//endregion

//# sourceMappingURL=JsWebSocketSession.mjs.map
